import { render, staticRenderFns } from "./GiftLink.vue?vue&type=template&id=4067d9a3&"
import script from "./GiftLink.vue?vue&type=script&lang=js&"
export * from "./GiftLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports